import templateUrl from './checkbox-template.html';

export const checkboxTemplateComponent = {
	bindings: {
		title: '@',
		options: '<',
		onChange: '&',
		isDisabled:'<'
	},
	templateUrl,
	controller: class CheckboxTemplateComponent {
		constructor($parse) {
			'ngInject';

			this.$parse = $parse;
		}
		$onInit() {
			if(this.isDisabled == undefined){
				this.isDisabled = false;
			}
			this.name = new Date().getTime() + Math.random();
		}
		
		_onChange($event, option) {
			this.onChange({
				$event: {
					option: option
				}
			});

		}
	}
};


// WEBPACK FOOTER //
// ./src/app/common/components/checkbox-template/checkbox-template.component.js